var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20" }, props),
    React.createElement(
      "title",
      null,
      "Min"
    ),
    React.createElement("path", { className: styles["oc-icon-indicator"] || "oc-icon-indicator", d: "M2.17 19v-1.5a1 1 0 0 1 1-1h13.66a1 1 0 0 1 1 1V19a1 1 0 0 1-1 1H3.17a1 1 0 0 1-1-1zm7.13-4.43a1 1 0 0 0 1.52 0l5.16-6a1 1 0 0 0-.75-1.65h-3.42v-5.8a1 1 0 0 0-1-1h-1.5a1 1 0 0 0-1 1V6.9H4.9a1 1 0 0 0-.76 1.65z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/Min.svg